export default "__VITE_ASSET__CDun2MVA__"